<template>
  <span class="Eyebrow" :class="`Eyebrow--${variant}`">
    <slot>{{ label }}</slot>
  </span>
</template>

<script setup lang="ts">
import type { EyebrowProps } from './Eyebrow.model';

withDefaults(defineProps<EyebrowProps>(), {
  variant: 'primary',
});
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/responsive';
@use '@cvo/ui/styles/utils/text';

@layer cvo-ui {
  .Eyebrow {
    @include text.text('sm');
    display: inline-flex;
    align-items: center;
    padding: vars.$dimensions-d-2 vars.$dimensions-d-4;
    color: vars.$atoms-eyebrow-text-color;
    border: vars.$dimensions-d-0-25 solid vars.$atoms-eyebrow-border-color;
    border-radius: vars.$border-radius-full;

    @include responsive.tablet {
      padding: vars.$dimensions-d-3 vars.$dimensions-d-5;
    }

    &--primary {
      background-color: var(--section-surface-color, #{vars.$atoms-eyebrow-primary-bg-color});
    }

    &--secondary {
      background-color: var(--section-surface-color, #{vars.$atoms-eyebrow-secondary-bg-color});
    }
  }
}
</style>
